'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var select = function select(state, selector) {
	return selector.reduce(function (prev, current) {
		return prev[current];
	}, state);
};

var ReduxWatcher = function () {
	function ReduxWatcher(store) {
		var _this = this;

		_classCallCheck(this, ReduxWatcher);

		var watchList = this.__watchList = {};
		this.__prevState = store.getState();
		store.subscribe(function () {
			var currentState = store.getState();
			var prevState = _this.__prevState;
			Object.keys(watchList).forEach(function (key) {
				var listeners = watchList[key];
				if (!listeners) {
					return;
				}
				var selector = JSON.parse(key);
				var prevValue = select(prevState, selector);
				var currentValue = select(currentState, selector);

				if (!(0, _isEqual2.default)(prevValue, currentValue)) {
					listeners.forEach(function (listener) {
						return listener({
							store: store,
							selector: selector,
							prevState: prevState,
							currentState: currentState,
							prevValue: prevValue,
							currentValue: currentValue
						});
					});
				}
			});
			_this.__prevState = currentState;
		});
		this.watch = this.watch.bind(this);
	}

	_createClass(ReduxWatcher, [{
		key: 'watch',
		value: function watch(selector, listener) {
			var watchList = this.__watchList;
			var selectorStr = JSON.stringify(selector);
			watchList[selectorStr] = watchList[selectorStr] || [];
			watchList[selectorStr].push(listener);
		}
	}, {
		key: 'off',
		value: function off(selector, listener) {
			var selectorStr = JSON.stringify(selector);
			if (!this.__watchList[selectorStr]) {
				console.warn('No such listener for ' + selector);
				return;
			}
			var listeners = this.__watchList[selectorStr];
			var listenerIndex = listeners.indexOf(listener);
			if (listenerIndex >= 0) {
				listeners.splice(listeners.indexOf(listener));
			} else {
				console.warn('No such listener for ' + selector);
			}
			if (listeners.length === 0) {
				delete this.__watchList[selectorStr];
			}
		}
	}]);

	return ReduxWatcher;
}();

exports.default = ReduxWatcher;
//# sourceMappingURL=redux-watcher.js.map



/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-watcher/dist/redux-watcher.js
 ** module id = 560
 ** module chunks = 0
 **/